import {
  DeclarationBasisDatesDataResp,
  SavedDeclarationBasisSettlementDataResp,
  HomeAssignmentDatesDataResp,
  SavedDeclarationBasisMARDataResp,
  SavedTodoDatesDataResp,
  KycFormResp,
} from '../forms/MyPagesAssignments/General/AssignmentConstants';

import {
  PersonalDataResp,
  StatisticObject,
  LoginInfo,
  GepositRoot,
  SpeculationResponse,
} from '../types/interfaces';

import {
  TagModel,
  GeneralInfo,
  EconomyInfo,
  AboutEstateInfo,
  SurroundingInfo,
  TechnicalInfo,
  Sale,
  Purchase,
  Suspension,
  QuestionList,
} from './generatedApi';
export const isDev = true;
// define URLs
export const apiUrl = 'https://app-lansfast-api.azurewebsites.net';
export const kycPortalUrl = 'https://kyc.lansfast.se';

//Is needed to make mypages login to work with correct claims
export const localApiUrl = 'http://localhost:5208';
export const websiteUrl = window.location.origin;
export const umbracoApi = '/umbraco/api';

export const getBrokerName = async (brokerId: string): Promise<string> => {
  const response = await fetch(
    apiUrl + `/api/Search/GetBrokerTag?brokerId=${brokerId}`
  );
  const data = (await response.json()) as string;
  return data;
};

export const getOfficeName = async (customerId: string): Promise<string> => {
  const response = await fetch(
    apiUrl + `/api/Search/GetOfficeTag?customerId=${customerId}`
  );
  const data = (await response.json()) as string;
  return data;
};

export const getPersonalData = async (
  ssn?: string
): Promise<PersonalDataResp> => {
  const response = await fetch(
    apiUrl + `/api/persondata/getpersoninformation?SSN=${ssn}`
  );
  const personalData = (await response.json()) as PersonalDataResp;
  return personalData;
};

export const getMunicipalityTag = async (
  municipality: string
): Promise<string> => {
  const response = await fetch(
    apiUrl + `/api/Search/CreateMunicipalityTags?municipality=${municipality}`
  );
  const data = (await response.json()) as TagModel;

  return data?.tag;
};

export const getCountyTag = async (county: string): Promise<string> => {
  const response = await fetch(
    apiUrl + `/api/Search/CreateCountyTags?county=${county}`
  );
  const data = (await response.json()) as TagModel;
  return data?.tag;
};

export const getQuestionListData = async (
  sessionId: string,
  estateId: string
): Promise<QuestionList> => {
  const SAVE_URL =
    `/api/MyPages/GetQuestionList?` +
    new URLSearchParams({ sessionId: sessionId, estateId: estateId });
  const response = await fetch(apiUrl + SAVE_URL);
  const data = (await response.json()) as QuestionList;

  return data;
};
export const getGeneralInfoData = async (
  sessionId: string,
  estateId: string
): Promise<GeneralInfo> => {
  const SAVE_URL =
    `/api/MyPages/HomeAssignment/GetGeneralInfo?` +
    new URLSearchParams({ sessionId: sessionId, estateId: estateId });
  const response = await fetch(apiUrl + SAVE_URL);
  const data = (await response.json()) as GeneralInfo;
  return data;
};

export const getEconomyInfoData = async (
  sessionId: string,
  estateId: string
): Promise<EconomyInfo> => {
  const SAVE_URL =
    `/api/MyPages/HomeAssignment/GetEconomyInfo?` +
    new URLSearchParams({ sessionId: sessionId, estateId: estateId });
  const response = await fetch(apiUrl + SAVE_URL);
  const data = (await response.json()) as EconomyInfo;
  return data;
};

export const getAboutEstateInfoData = async (
  sessionId: string,
  estateId: string
): Promise<AboutEstateInfo> => {
  const SAVE_URL =
    `/api/MyPages/HomeAssignment/GetAboutEstateInfo?` +
    new URLSearchParams({ sessionId: sessionId, estateId: estateId });
  const response = await fetch(apiUrl + SAVE_URL);
  const data = (await response.json()) as AboutEstateInfo;
  return data;
};

export const getHomeAssignmentDates = async (
  sessionId: string,
  estateId: string
): Promise<HomeAssignmentDatesDataResp> => {
  const SAVE_URL =
    `/api/MyPages/HomeAssignment/GetDates?` +
    new URLSearchParams({ sessionId: sessionId, estateId: estateId });
  const response = await fetch(apiUrl + SAVE_URL);
  const data = (await response.json()) as HomeAssignmentDatesDataResp;
  return data;
};

export const getSurroundingInfoData = async (
  sessionId: string,
  estateId: string
): Promise<SurroundingInfo> => {
  const SAVE_URL =
    `/api/MyPages/HomeAssignment/GetSurroundingInfo?` +
    new URLSearchParams({ sessionId: sessionId, estateId: estateId });
  const response = await fetch(apiUrl + SAVE_URL);
  const data = (await response.json()) as SurroundingInfo;
  return data;
};

export const getTechnicalInfoData = async (
  sessionId: string,
  estateId: string
): Promise<TechnicalInfo> => {
  const SAVE_URL =
    `/api/MyPages/HomeAssignment/GetTechnicalInfo?` +
    new URLSearchParams({ sessionId: sessionId, estateId: estateId });
  const response = await fetch(apiUrl + SAVE_URL);
  const data = (await response.json()) as TechnicalInfo;
  return data;
};

export const getDeclarationBasisDates = async (
  sessionId: string,
  estateId: string
): Promise<DeclarationBasisDatesDataResp> => {
  const GET_URL =
    `/api/MyPages/DeclarationBasis/GetDates?` +
    new URLSearchParams({ sessionId: sessionId, estateId: estateId });
  const response = await fetch(apiUrl + GET_URL);
  const data = (await response.json()) as DeclarationBasisDatesDataResp;
  return data;
};

export const getDeclarationBasisSettlement = async (
  sessionId: string,
  estateId: string
): Promise<SavedDeclarationBasisSettlementDataResp> => {
  const GET_URL =
    `/api/MyPages/DeclarationBasis/GetSettlement?` +
    new URLSearchParams({ sessionId: sessionId, estateId: estateId });
  const response = await fetch(apiUrl + GET_URL);
  const data =
    (await response.json()) as SavedDeclarationBasisSettlementDataResp;
  return data;
};

export const getDeclarationBasisSale = async (
  sessionId: string,
  estateId: string
): Promise<Sale> => {
  const GET_URL =
    `/api/MyPages/DeclarationBasis/GetSale?` +
    new URLSearchParams({ sessionId: sessionId, estateId: estateId });
  const response = await fetch(apiUrl + GET_URL);
  const data = (await response.json()) as Sale;
  return data;
};

export const getDeclarationBasisPurchase = async (
  sessionId: string,
  estateId: string
): Promise<Purchase> => {
  const GET_URL =
    `/api/MyPages/DeclarationBasis/GetPurchase?` +
    new URLSearchParams({ sessionId: sessionId, estateId: estateId });
  const response = await fetch(apiUrl + GET_URL);
  const data = (await response.json()) as Purchase;
  return data;
};

export const getDeclarationBasisSuspension = async (
  sessionId: string,
  estateId: string
): Promise<Suspension> => {
  const GET_URL =
    `/api/MyPages/DeclarationBasis/GetSuspension?` +
    new URLSearchParams({ sessionId: sessionId, estateId: estateId });
  const response = await fetch(apiUrl + GET_URL);
  const data = (await response.json()) as Suspension;
  return data;
};

export const getDeclarationBasisMAR = async (
  sessionId: string,
  estateId: string
): Promise<SavedDeclarationBasisMARDataResp> => {
  const GET_URL =
    `/api/MyPages/DeclarationBasis/GetMaintenanceAndRebuilding?` +
    new URLSearchParams({ sessionId: sessionId, estateId: estateId });
  const response = await fetch(apiUrl + GET_URL);
  const data = (await response.json()) as SavedDeclarationBasisMARDataResp;
  return data;
};

export const getToDoDates = async (
  sessionId: string,
  estateId: string
): Promise<SavedTodoDatesDataResp> => {
  const SAVE_URL =
    `/api/MyPages/GetToDoDates?` +
    new URLSearchParams({ sessionId: sessionId, estateId: estateId });
  const response = await fetch(apiUrl + SAVE_URL);
  const data = (await response.json()) as SavedTodoDatesDataResp;
  return data;
};

export const getKycForm = async (
  userId: string,
  estateId: string
): Promise<KycFormResp | null> => {
  const GET_URL =
    `/api/User/GetKycForms?` +
    new URLSearchParams({ sessionId: userId, estateId: estateId });
  const response = await fetch(apiUrl + GET_URL);
  const data = await response.json();
  return data || null;
};

export const getWebsiteVisitor = async (
  estateId: string,
  sessionId: string
): Promise<StatisticObject[]> => {
  const GET_URL =
    `/api/Statistics/SourceData?` +
    new URLSearchParams({ estateId: estateId, sessionId: sessionId });

  const response = await fetch(apiUrl + GET_URL);
  const objectWebsiteStats = (await response.json()) as StatisticObject[];
  return objectWebsiteStats;
};

export const getMunicipalityData = async (
  estateId: string,
  sessionId: string
): Promise<StatisticObject> => {
  const GET_URL =
    `/api/Statistics/MunicipalityData?` +
    new URLSearchParams({ estateId: estateId, sessionId: sessionId });

  const response = await fetch(apiUrl + GET_URL);

  const objectWebsiteStats = await response.json();
  return objectWebsiteStats;
};
export const getObjectTypeData = async (
  estateId: string,
  sessionId: string
): Promise<StatisticObject> => {
  const GET_URL =
    `/api/Statistics/ObjectTypeData?` +
    new URLSearchParams({ estateId: estateId, sessionId: sessionId });

  const response = await fetch(apiUrl + GET_URL);
  const objectData = (await response.json()) as StatisticObject;
  return objectData;
};

export const getLoginInfo = async (): Promise<LoginInfo> => {
  const GET_URL = '/userapi/login';
  const response = await fetch(websiteUrl + umbracoApi + GET_URL);
  const loginInfo = (await response.json()) as LoginInfo;
  return loginInfo;
};

export const getGepositData = async (query: string): Promise<GepositRoot> => {
  const GET_URL =
    `/api/Forms/GetGepositData?` + new URLSearchParams({ query: query });

  const response = await fetch(apiUrl + GET_URL);
  const specResult = (await response.json()) as GepositRoot;
  return specResult;
};

export const getNrOfSpeculators = async (
  data: any
): Promise<SpeculationResponse> => {
  const POST_URL = `/api/Forms/SpeculatorCheck`;

  const response = await fetch(apiUrl + POST_URL, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (response.ok) {
    const specResult = (await response.json()) as SpeculationResponse;
    return specResult;
  } else {
    data.setError('serverError', {
      type: 'manual',
      message: response,
    });
  }
};
